import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectStore} from "../../../../../../../store/selector";
import {StyledSelectSpecialtyContainer} from "./index.styles";
import {Alert, Button, Col, message, Progress, Row, Table, Form, Select} from "antd";
import {MyInput} from "../../../../../../common/MyInput/MyInput";
import {
  createSelectedSpecialityAction,
  deleteSelectedSpecialityAction,
  changeSelectedSpecialityPriorityAction,
  fetchCollegesWithQualificationsAction,
  fetchCollegesWithQualificationsActionReset, fetchDataForSpecialitiesFormAction
} from "../../../../../../../store/pages/admission/actions";
import {useTranslation} from "react-i18next";
import {MyButton} from "../../../../../../common/MyButton/MyButton";

import {
  StepOneRightArrow,
  StepOneLeftArrow,
  StepOneIcon,
  DeleteIcon,
  IconError,
  WarningIcon
} from "../../../../../../../assets";
import {fetchCollegesWithQualification} from "../../../../../../../store/pages/admission/api";

const {Option} = Select

const layout = {
  labelCol: { span: 3 },
  labelAlign: "left",
  wrapperCol: { span: 16 },
  size: "large"
};

export const SelectSpecialty = ({formDataTop, educationForm, educationType, pay_form, error, setError, user_id, setProfileType, profileType}:any) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { t } = useTranslation('admission');

  const {profile: {userProfile: profileState},admission: {arrayOfSpecialities, arrayOfSpecialitiesDataFromApi, educationOrder, collegeForArrayOfSpecialities,}} = useSelector(selectStore);

  // useEffect(() => {
  //   console.log("arrayOfSpecialities",arrayOfSpecialities)
  // }, [arrayOfSpecialities]);

  const MIN = 1;
  const MAX = educationType === '1' && pay_form !== '1' ? 1 : (arrayOfSpecialities.data || []).length;

  const initValue = {
    language_id: '',
    profile: '',
    specialization: '',
    qualification: '',
    college: '',
  }

  const initIdxValue = {
    idxProfile: null,
    idxSpecialization: null,
    idxQualification: null,
    idxCollege: null
  }

  const [formData, setFormData] = useState(initValue)
  const [idxForSelect, setIdxForSelect] = useState(initIdxValue)

  useEffect(() => {
    if (educationType === '1' && (arrayOfSpecialities.data || null).length >= 2) {

      message.error(t("stepTwo.workingStaffError"))
    }
    // eslint-disable-next-line
  }, [educationType])

  useEffect(() => {
    if ((arrayOfSpecialities.data || []).length >= 2) {
      const priority = new Set(arrayOfSpecialities.data.map((specialty:any) => specialty.priority))

      // @ts-ignore
      const result = ([...priority] || []).length !== (arrayOfSpecialities.data || []).length
      setError(result)
    }
    // eslint-disable-next-line
  }, [arrayOfSpecialities.data])

  const onValuesChange = (changedField:any, allFields:any) => {
    setFormData(allFields)

    console.log("changedField",changedField)

    if (changedField.language_id && allFields.profile_id) {
      form.resetFields(["profile_id", "speciality_id", "qualification_id", "college_id"])
      dispatch(fetchCollegesWithQualificationsActionReset())

      setIdxForSelect((prevState:any) => ({
        ...prevState,
        idxProfile: null,
        idxSpecialization: null,
        idxQualification: null,
        idxCollege: null,
      }))

      setFormData((prevState:any) => ({
        ...prevState,
        profile_id: null,
        speciality_id: null,
        qualification_id: null,
        college_id: null
      }))
    } else if (changedField.profile_id && allFields.speciality_id) {
      form.resetFields(["speciality_id", "qualification_id", "college_id"])
      dispatch(fetchCollegesWithQualificationsActionReset())

      setIdxForSelect((prevState:any) => ({
        ...prevState,
        idxSpecialization: null,
        idxQualification: null,
        idxCollege: null,
      }))

      setFormData((prevState:any) => ({
        ...prevState,
        speciality_id: null,
        qualification_id: null,
        college_id: null
      }))
    } else if (changedField.speciality_id && allFields.qualification_id) {
      form.resetFields(['qualification_id', 'college_id'])
      dispatch(fetchCollegesWithQualificationsActionReset())

      setIdxForSelect((prevState:any) => ({
        ...prevState,
        idxQualification: null,
        idxCollege: null,
      }))

      setFormData((prevState:any) => ({
        ...prevState,
        qualification_id: null,
        college_id: null
      }))
    } else if (changedField.qualification_id && allFields.college_id) {
      form.resetFields(['college_id'])
      dispatch(fetchCollegesWithQualificationsActionReset())

      setIdxForSelect((prevState:any) => ({
        ...prevState,
        idxCollege: null,
      }))

      setFormData((prevState:any) => ({
        ...prevState,
        college_id: null
      }))
    }

    if(allFields.language_id && allFields.profile_id && allFields.speciality_id && allFields.qualification_id){
      let body = {
        qualificationId: allFields.qualification_id,
        educationForm: educationForm,
        lang: allFields.language_id,
        baseEducation: educationOrder.data.base_education,
        isPayer: pay_form == "2",
      }

      dispatch(fetchCollegesWithQualificationsAction(body))
    }

    if (allFields.language_id && allFields.profile_id && allFields.speciality_id && allFields.qualification_id && allFields.college_id) {
      let doneObject = {
        ...allFields,
        educationOrderId: educationOrder.data.id,
        priority: (arrayOfSpecialities.data || []).length + 1,
        user_id,
        is_entrant: !(profileState.data && Array.isArray(profileState.data.roles) && profileState.data.roles.some((item: any) => item === "executor"))
      }
      // console.log('doneObject',doneObject)

      dispatch(createSelectedSpecialityAction(doneObject))
      setTimeout(() => {
        setFormData(initValue)
        form.resetFields();
      }, 1)
    }
  }

  const onChangeSelect = (key:any, option:any) => {
   if((option.profile_type || option.profile_type === 0) && profileType !== option.profile_type){
     setProfileType(option.profile_type)
   }

    setIdxForSelect((prevState:any) => ({
      ...prevState,
      [key]: option.id
    }))
  }

  const onHandleClickPriorityButton = (key:any, record:any) => {
    let body
    if (key === 'increase') {
      if (record.priority >= MAX) {
        // eslint-disable-next-line
        message.info(`${t("stepTwo.moreThanError")} ${MAX}`)
      }
      body = {
        id: record.id,
        priority: record.priority >= MAX ? record.priority : record.priority + 1
      }
    } else {
      if (record.priority <= MIN) {
        // eslint-disable-next-line
        message.info(`${t("stepTwo.lessThanError")}`)
      }
      body = {
        id: record.id,
        priority: record.priority <= MIN ? record.priority : record.priority - 1
      }
    }

    // @ts-ignore
    dispatch(changeSelectedSpecialityPriorityAction(body))
  }

  /**
   * @description Func, that take lang number from api and return correct name for display
   * @return string name of language
   */
  const currentLanguageOfSpecialty = (langNumber:any) => {
    const objOfLanguages = {
      1: 'Казахский',
      2: 'Русский',
      3: 'Английский'
    }

    // @ts-ignore
    return objOfLanguages[langNumber]
  }

  const handleShowMessage = () => {
    const remainingSpecialities = arrayOfSpecialities ? 4 - arrayOfSpecialities.data.length : 4;

    return <>{remainingSpecialities > 0 ? (<span>Вы можете выбрать ещё <strong>{remainingSpecialities} специальности</strong></span>) : null}</>
  }

  const columns = [
    {
      title: t("stepTwo.specialtyForm.specialty"),
      render: (text: any, record: any) => (
        <p>{record.speciality.code} - {record.speciality.caption}</p>
      )
    },
    {
      title: t("stepTwo.specialtyForm.qualification"),
      render: (text:any, record:any) => (
        <p>{record.qualification.code} - {record.qualification.caption}</p>
      )
    },
    {
      title: t("stepTwo.specialtyForm.college"),
      render: (text:any, record:any) => (
        <p>{record.college.name}</p>
      )
    },
    {
      title: t("stepTwo.specialtyForm.language"),
      dataIndex: 'language_of_education',
      render: (text:any, record:any) => (
        <>
          <p>{currentLanguageOfSpecialty(record.language_of_education)}</p>
        </>
      )
    },
    {
      title: t("stepTwo.specialtyForm.priority"),
      key: 'priority',
      width: '85px',
      render: (text:any, record:any) => (
        <Row justify='center' align="middle">
          <Button style={{width: 16, height: 16, marginRight: 5}} ghost icon={<StepOneLeftArrow style={{position: "relative", bottom: 4}}/>} onClick={() => onHandleClickPriorityButton('decrease', record)}/>
          <span style={{position: 'relative', top: 0}}>{record.priority}</span>
          {/*<MyInput style={{ width: '31px', backgroundColor: "#fff", color: "#000" }} disabled value={record.priority}/>*/}
          <Button style={{width: 16, height: 16, marginLeft: 5}} ghost icon={<StepOneRightArrow style={{position: "relative", bottom: 4}}/>} onClick={() => onHandleClickPriorityButton('increase', record)}/>
        </Row>
      )
    },
    {
      title: t("stepTwo.specialtyForm.delete"),
      key: 'delete',
      width: '60px',
      render: (text:any, record:any) => (
        <>
          <MyButton ghost icon={<DeleteIcon style={{ position: 'relative', bottom: '1px' }}/>}
                  onClick={() => {
                    if(arrayOfSpecialities.data && arrayOfSpecialities.data.length === 1){
                      dispatch(fetchDataForSpecialitiesFormAction({type: educationType}));
                      setProfileType(null)
                    }
                    // @ts-ignore
                    dispatch(deleteSelectedSpecialityAction({id: record.id, priority: record.priority}))
                  }}/>
        </>
      )
    },
  ]

  return(
    <StyledSelectSpecialtyContainer>
      <h2 style={{ marginLeft: '32px' }}>{t('stepTwo.specialtyForm.label')}</h2>
      <Row style={{ marginLeft: '32px' }}>
        <Col>
          <div className='first-step-icon'>
            <StepOneIcon/>
          </div>
        </Col>
        <Col offset={1} span={21} style={{ marginLeft: '27px' }}>
          <Progress percent={educationType === '2' && pay_form === '1' ? (arrayOfSpecialities.data || []).length * 25 : (arrayOfSpecialities.data || []).length * 100}
                    strokeColor={{
                      '0%': '#209D43',
                      '100%': '#2BC255',
                    }} showInfo={false}/>
          <p
            className='progress-subtitle'>{t('stepTwo.specialtyForm.specialty')} {(arrayOfSpecialities.data || []).length}/{educationType === '2' && pay_form === '1' ? 4 : 1}</p>
        </Col>
      </Row>

      {(educationType === '2' && pay_form === '1' ? ((arrayOfSpecialities.data || []).length) !== 4 : (((arrayOfSpecialities.data || []).length) !== 1 && ((arrayOfSpecialities.data || []).length) <= 1)) ?
        <>
          <Col offset={1} span={21} className='main-container'>
            <p>{t('stepTwo.specialtyForm.specialty')} {((arrayOfSpecialities.data || []).length) + 1}</p>

            {/*//@ts-ignore*/}
            <Form {...layout} onValuesChange={onValuesChange} form={form} name='four-specialities'
                  style={{padding: '0 12px'}}>
              <Form.Item name='language_id' label={t('stepTwo.specialtyForm.language')}
                         rules={[{required: true, message: 'Необходимо выбрать язык обучения'}]}>
                <Select showSearch
                        placeholder={arrayOfSpecialitiesDataFromApi.loading ? 'Загрузка списков...' : t('stepTwo.specialtyForm.selectList')}
                        disabled={arrayOfSpecialitiesDataFromApi.loading || !arrayOfSpecialitiesDataFromApi.data}
                  //@ts-ignore
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                  {arrayOfSpecialitiesDataFromApi?.data?.profilesWithChildren && arrayOfSpecialitiesDataFromApi.data && arrayOfSpecialitiesDataFromApi.data.languages && arrayOfSpecialitiesDataFromApi.data.languages.map((language: any) => (
                    <Option key={language.id} value={language.id}>{language.caption}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='profile_id' label={t('stepTwo.specialtyForm.profile')}
                         rules={[{required: true, message: 'Необходимо выбрать профиль'}]}>
                <Select showSearch
                        disabled={!formData.language_id}
                  // disabled={!formData.language_id || fourSpecialtiesFromApi.loading || !fourSpecialtiesFromApi.data}
                        placeholder={t('stepTwo.specialtyForm.selectList')}
                        onChange={(value, option) => onChangeSelect('idxProfile', option)}
                  //@ts-ignore
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                  {arrayOfSpecialitiesDataFromApi?.data?.profilesWithChildren && !arrayOfSpecialitiesDataFromApi.loading && arrayOfSpecialitiesDataFromApi.data && arrayOfSpecialitiesDataFromApi?.data?.profilesWithChildren && arrayOfSpecialitiesDataFromApi?.data?.profilesWithChildren.map((profile: any, idx: any) => (
                    <Option key={profile.id} id={idx} value={profile.id}>{profile.caption}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='speciality_id' label={t('stepTwo.specialtyForm.specialty')}
                         rules={[{required: true, message: 'Необходимо выбрать специальность'}]}>
                {/*//@ts-ignore*/}
                <Select showSearch disabled={!formData.profile_id} placeholder={t('stepTwo.specialtyForm.selectList')}
                        onChange={(value, option) => onChangeSelect('idxSpecialization', option)}
                  //@ts-ignore
                        filterOption={(input, option) => option?.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0 || option?.children[2].toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                  {/*//@ts-ignore*/}
                  {arrayOfSpecialitiesDataFromApi?.data?.profilesWithChildren && formData.profile_id && arrayOfSpecialitiesDataFromApi?.data?.profilesWithChildren[idxForSelect.idxProfile]?.specialities && arrayOfSpecialitiesDataFromApi?.data?.profilesWithChildren[idxForSelect.idxProfile]?.specialities.map((specialty, idx) => (
                    <Option key={specialty.id} id={idx} profile_type={specialty.profile_type}
                            value={specialty.id}>{specialty.code} - {specialty.caption}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='qualification_id' label={t('stepTwo.specialtyForm.qualification')}
                         rules={[{required: true, message: 'Необходимо выбрать квалификацию'}]}>
                {/*//@ts-ignore*/}
                <Select showSearch disabled={!formData.speciality_id}
                        placeholder={t('stepTwo.specialtyForm.selectList')}
                        onChange={(value, option) => onChangeSelect('idxQualification', option)}
                  //@ts-ignore
                        filterOption={(input, option) => option?.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0 || option?.children[2].toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                  {/*//@ts-ignore*/}
                  {arrayOfSpecialitiesDataFromApi?.data?.profilesWithChildren && formData.speciality_id && arrayOfSpecialitiesDataFromApi?.data?.profilesWithChildren[idxForSelect.idxProfile]?.specialities[idxForSelect.idxSpecialization]?.qualifications && arrayOfSpecialitiesDataFromApi?.data?.profilesWithChildren[idxForSelect.idxProfile]?.specialities[idxForSelect.idxSpecialization]?.qualifications.map((qualification, idx) => (
                    <Option key={qualification.id} id={idx}
                            value={qualification.id}>{qualification.code} - {qualification.caption}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='college_id' label={t('stepTwo.specialtyForm.college')}
                         rules={[{required: true, message: 'Необходимо выбрать колледж'}]}>
                {/*//@ts-ignore*/}
                <Select loading={collegeForArrayOfSpecialities.loading} showSearch disabled={!formData.qualification_id}
                        placeholder={t('stepTwo.specialtyForm.selectList')}
                        onChange={(value, option) => onChangeSelect('idxCollege', option)}
                  //@ts-ignore
                        filterOption={(input, option) => option?.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0 || option?.children[2].toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                  {/*//@ts-ignore*/}
                  {collegeForArrayOfSpecialities?.data.map((college, idx) => (
                    <Option key={college.id} id={idx} value={college.id}>{college.name}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          </Col>
          {/*education_form*/}
          {/*pay_form*/}
          {/*education_type*/}

          {formDataTop.education_form != "1" || formDataTop.pay_form != "1" || formDataTop.education_type != "2" ? null : (
            <Alert
              style={{marginTop: 12}}
              className="admission__error"
              message={handleShowMessage()}
              type="warning"
              showIcon
              icon={<WarningIcon/>}
            />
          )}
        </>
        : null}

      {((arrayOfSpecialities.data || []).length) > 0 ?
        <>
          <hr/>
          <div style={{ marginTop: '24px' }}>
            <h2>{t("stepTwo.selectedSpecialities")}</h2>
            {error ? <Alert
              className="admission__error"
              message={t('stepTwo.specialtyForm.error.priority')}
              type="warning"
              showIcon
              icon={<div><IconError /></div>}
            /> : null}
            <Table rowKey={(record:any) => record.id} bordered pagination={false} dataSource={arrayOfSpecialities.data}
                   columns={columns}/>
          </div>

          {educationType === '2' && pay_form === '1' ? (
            <Alert
              style={{marginTop: 12}}
              className="admission__error"
              message={t("stepTwo.alertPriorityText")}
              type="warning"
              showIcon
              icon={<WarningIcon/>}
            />
          ) : null}
        </>
        : null}
    </StyledSelectSpecialtyContainer>
  )
}